import BuildingShadow from './BuildingShadow'
import SunlightMapContent from './SunlightMapContent'

export { default } from './Sunlight'

export const SunlightMapConfig = {
  Content: SunlightMapContent,
  Controller: BuildingShadow,
}
